<template>
    <div
        class="tab-pane fade show active"
        id="contact-tab-pane"
        role="tabpanel"
        aria-labelledby="contact-tab"
        tabindex="0"
    >
        <div class="row">
            <div class="col-lg-10">
                <!-- @submit.prevent="handleSubmit" -->
                <div class="row g-3 needs-validation form-fields">
                    <div
                        v-for="(field, index) in fields"
                        :key="index"
                        class="field col-md-6"
                    >
                        <label class="form-label"
                            >{{ field.name }}
                            <span v-if="field.required">*</span></label
                        >
                        <input 
                            v-if="field.data_type === 'telephone'"
                            @input="formatPhone"
                            :type="field.data_type"
                            class="form-control"
                            :placeholder="field.description??''"
                            maxlength="14"
                            :id="`field-${field.internal_col_name}`"
                            :value="getFieldValue(field)"
                            :data-default-value="getFieldValue(field)"
                            :field_name="field.internal_col_name"
                            :data-efs-id="field.efs_id"
                        />
                        <input
                            v-else-if="field.data_type === 'number'"
                            :type= "field.data_type"
                            class="form-control"
                            :placeholder="field.description ?? ''"
                            :id="`field-${field.internal_col_name}`"
                            :readonly="fieldConfig[`READONLY_FIELD-${field.efs_id}`] === '1'"
                            :value="getFieldValue(field)"
                            :data-default-value="getFieldValue(field)"
                            :field_name="field.internal_col_name"
                            :data-efs-id="field.efs_id"
                            min="0"
                        />
                        <input
                            v-else-if="field.data_type === 'email'"
                            :type= "field.data_type"
                            class="form-control"
                            :placeholder="field.description ?? ''"
                            :id="`field-${field.internal_col_name}`"
                            :readonly="fieldConfig[`READONLY_FIELD-${field.efs_id}`] === '1'"
                            :value="getFieldValue(field)"
                            :data-default-value="getFieldValue(field)"
                            :field_name="field.internal_col_name"
                            :data-efs-id="field.efs_id"
                        />
                        <div class="select" v-else-if="field.data_type === 'select'">
                            <select name=""
                                class="form-select"
                                :id="`field-${field.internal_col_name}`"
                                :value="getFieldValue(field)"
                                :disabled="fieldConfig[`READONLY_FIELD-${field.efs_id}`] === '1'"
                                :field_name="field.internal_col_name"
                                :data-efs-id="field.efs_id"
                            >
                                <option value=""></option>
                                <option v-for="(option, index) in field.options" :key="index" :value="option.value">{{option.label}}</option>
                            </select>
                        </div>
                        <input
                            v-else
                            :type="field.data_type"
                            class="form-control"
                            :placeholder="field.description ?? ''"
                            :id="`field-${field.internal_col_name}`"
                            :readonly="fieldConfig[`READONLY_FIELD-${field.efs_id}`] === '1'"
                            :value="getFieldValue(field)"
							:data-default-value="getFieldValue(field)"
							:field_name="field.internal_col_name"
							:data-efs-id="field.efs_id"
                        />

                    </div>

                    <!-- <div class="col-md-6">
						<label for="firstName" class="form-label">Prénom <span>*</span></label>
						<input type="text" class="form-control" id="firstName" :value="fields" placeholder="Prénom" required>
					</div>

					<div class="col-md-6">
						<label for="email" class="form-label">Email <span>*</span></label>
						<input type="email" class="form-control" id="email" v-model="form.email" placeholder="Email" required>
					</div>

					<div class="col-md-6">
						<label for="mobile" class="form-label">Mobile <span>*</span></label>
						<input type="text" class="form-control" id="mobile" v-model="form.mobile" placeholder="Mobile">
					</div>

					<div class="col-md-6">
						<label for="city" class="form-label">Ville <span>*</span></label>
						<input type="text" class="form-control" id="city" v-model="form.city" placeholder="Ville" required>
					</div> -->

                </div>
            </div>
			<div class="col-lg-10 d-flex align-items-end justify-content-end my-3 gap-3">
				<button class="btn-primary1" @click="save">
					Sauvegarder
				</button>
                <button class="btn-cancel text-center" @click="show = true">
                    Supprimer
				</button>
                <AnnulationPopUp
                    v-model:show="show" 
                    @confirm="deleteAccount"
                    title="Confirmation de suppression du compte"
                    description="La suppression de votre compte entraînera l’annulation et la suppression définitive de l’ensemble de vos rendez-vous, qu’ils soient passés ou à venir."
                    notes="Cette action est irréversible."
                    textConfirmationButton="Oui, supprimer"
                    textCancelButton="Non, conserver"
                />
			</div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { toast } from "bulma-toast";
import { Inertia } from "@inertiajs/inertia";
import AnnulationPopUp from "./AnnulationPopUp.vue"
import { validateEmail, validatePhone } from '../../../utils/validationUtils';


export default {
    name: "MesInformation",
    components: { AnnulationPopUp },
    computed: {
        user() {
            return this.$page.props.auth.user?.client?.[0];
        },
    },
    data() {
        return {
            show: false,
            error_message: null,
            fields: [],
            fieldConfig: [],
            is_loading: false
        };
    },
    methods: {
        handleSubmit() {
            //   console.log('Form submitted:', this.form);
            console.log(this.fields);
        },
        getFields() {
            axios.get("/client/informations").then((response) => {
                this.fields = response.data.fields.sort((a, b) => a.position - b.position);
                this.fieldConfig = response.data.fieldConfig;

                // this.fields = response.data.sort(
                //     (a, b) => a.position > b.position
                // );
            });
        },
        getFieldValue(field) {
            let value = this.user[field.internal_col_name] ?? "";
            if (field.data_type === "date" && this.isDateSupported()) {
                value = value.split("/").reverse().join("-");
            }
            return value;
        },
        formatPhone(ev) {
            let input = ev.target;
            let value = input.value;
            let digits = value.replaceAll(/[^0-9]/g, "")
                    ?.match(/.{1,2}/g)
                    ?.join(".") ?? "";
            input.value = digits;
        },
        isDateSupported() {
            let input = document.createElement("input");
            let value = "a";
            input.setAttribute("type", "date");
            input.setAttribute("value", value);
            return input.value !== value;
        },
        getIsChecked(field, option) {
            if (!this.user[field.internal_col_name]) return false;
            return this.user[field.internal_col_name]
                .split(",")
                .includes(option);
        },
        hideDeleteAccount() {
            let modal = document.querySelector("#delete-account-modal");
            modal.classList.remove("is-active");
            this.rdvToCancel = null;
        },
        showDeleteAccount(rdv) {
            let modal = document.querySelector("#delete-account-modal");
            modal.classList.add("is-active");
            this.rdvToCancel = rdv.rdv_id;
        },
        save() {
            let fields = document.querySelectorAll(".form-fields [field_name]");
            let data = {};
            for (let field of fields) {
                if (field.getAttribute("type") === "checkbox" && !field.checked)
                    continue;
                let field_name = field.getAttribute("field_name");
                let elt = data[field_name] || [];
                if (field.value || field.getAttribute("value"))
                    elt.push(field.value || field.getAttribute("value"));
                data[field_name] = elt;
                // console.log(field);
                // console.log(field.value || field.getAttribute("value"));
            }
            for (let key in data) {
                let field = this.fields.find(
                    (field) => field.internal_col_name === key
                );
                if (field.data_type !== "checkbox")
                    data[key] = data[key].toString();
                if (field.required && !data[key]) {
                    let field_name = field.name
                    ? field.name?.toLowerCase()
                    : null;
                    this.error_message = field_name
                    ? `Le champ "${field_name}" est obligatoire.`
                    : "Merci de renseigner tous les champs obligatoires.";
                    return false;
                }
                if (field.data_type === "date") {
                    let result = /^(\d{4})-(\d{2})-(\d{2})$/.exec(data[key]);
                    if (result) {
                        data[key] = `${result[3]}/${result[2]}/${result[1]}`;
                    } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(data[key])) {
                    } else {
                        let field_name = field.name.toLowerCase();
                        this.error_message = `Le champ "${field_name}" doit être une date valide.`;
                        return false;
                    }
                }
                if (field.data_type === "telephone" && data[key]) {
                    const validation = validatePhone(data[key], field.name);
                    console.log('validation phone', validation);
                    
                    if (!validation.valid) {
                        toast({
                            message: validation.message,
                            type: "is-danger",
                            duration: 5000,
                            pauseOnHover: true,
                        });
                        return false;
                    }
                }
                if (field.data_type === "email" && data[key]) {
                    const validation = validateEmail(data[key], field.name);
                    if (!validation.valid) {
                        toast({
                            message: validation.message,
                            type: "is-danger",
                            duration: 5000,
                            pauseOnHover: true,
                        });
                        return false;
                    }
                }
                if (field.data_type === "number" && data[key]) {
                    let numberValue = Number(data[key].replace(/,/g, '.'));
                    let field_name = field.name?.toLowerCase() || key;
                    const configKey = `MAX_LIMITE-${field.efs_id}`;
                    let maxValue = this.config?.[configKey];
                    if (isNaN(numberValue) || numberValue < 0) {
                        toast({
                            message: `Le champ "${field_name}" doit être un nombre positif.`,
                            type: 'is-danger',
                            duration: 5000,
                            pauseOnHover: true
                        })
                        return false;
                    }
                    if (field.internal_col_name !== "zipcode" && numberValue > maxValue) {
                        toast({
                                message: `Le champ "${field_name}" doit être inférieur à "${maxValue}".`,
                                type: 'is-danger',
                                duration: 5000,
                                pauseOnHover: true
                        })
                        return false;
                    }
                    data[key] = numberValue;
                }
            }
            this.error_message = null;
            this.is_loading = true;
            axios
                .post("modify_client", data)
                .then((response) => {
                    Inertia.reload({ only: ["auth.user"] });
                    this.is_loading = false;
                    toast({
                        message:
                            response?.data?.message ||
                            "Vos changements ont bien été pris en compte.",
                        type: "is-success",
                        duration: 3000,
                        pauseOnHover: true,
                    });
                })
                .catch((err) => {
                    if (err?.response?.data?.errors) {
                        for (let error in err?.response?.data?.errors) {
                            err.response.data.errors[error].forEach(
                                (message) => {
                                    toast({
                                        message: message,
                                        type: "is-danger",
                                        duration: 5000,
                                        pauseOnHover: true,
                                    });
                                }
                            );
                        }
                    } else {
                        toast({
                            message:
                                "Vos changements n'ont pas pu être pris en compte.",
                            type: "is-danger",
                            duration: 5000,
                            pauseOnHover: true,
                        });
                    }
                    this.is_loading = false;
                });
        },
        deleteAccount() {
            axios.delete("/account").then((response) => {
                if (response.status == 200) {
                    toast({
                        message: "Le compte a été supprimé avec succès.",
                        type: "is-success",
                        duration: 3000,
                        pauseOnHover: true,
                    });
                    
                    this.show = false;
                    setTimeout(() => {
                        window.location.href = "/";
                    }, 1000);
                } else {
                    toast({
                        message: "Erreur lors de la suppression du compte.",
                        type: "is-danger",
                        duration: 3000,
                        pauseOnHover: true,
                    });
                    this.show = false;
                }
            }).catch((err) => {
                toast({
                    message: "Erreur lors de la suppression du compte.",
                    type: "is-danger",
                    duration: 3000,
                    pauseOnHover: true,
                });
                this.show = false;
            });
        },
    },
    mounted() {
        this.getFields();
    },
};
</script>
